/*
 * @providesModule MergeAccountScreenStyle
 *
 */

import SkillzStyle from 'SkillzStyle';
import {StyleSheet, Platform} from 'react-native';

export default StyleSheet.create({
  balanceText: {
    ...SkillzStyle.fullStyles.fontRegular,
    fontSize: 15,
    textAlign: 'center',
  },

  newBalanceText: {
    ...SkillzStyle.fullStyles.fontRegular,
    fontSize: 16,
    textAlign: 'center',
    fontWeight: '700',
    marginTop: 10,
    ...SkillzStyle.fullStyles.textColorPrimary,
  },

  bodyContainer: {
    flex: 1,
    justifyContent: 'center',
  },

  bodyText: {
    textAlign: 'center',
    ...SkillzStyle.fullStyles.fontRegular,
    fontSize: 20,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: '8%',
  },

  newBodyText: {
    textAlign: 'center',
    ...SkillzStyle.fullStyles.fontRegular,
    ...SkillzStyle.fullStyles.textColorPrimary,
    fontSize: 28,
    fontStyle: 'normal',
    fontWeight: '700',
    marginBottom: 19,
  },

  button: {
    backgroundColor: 'rgb(46, 114, 242)',
    borderRadius: 100,
    width: 300,
    alignSelf: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    padding: 8,
  },

  newButton: {
    height: 56,
    paddingVertical: 7,
    paddingHorizontal: 9,
  },

  buttonText: {
    textAlign: 'center',
    ...SkillzStyle.fullStyles.fontRegular,
    fontSize: 18,
    fontStyle: 'normal',
    color: '#FFF',
  },

  container: {
    flex: 1,
    paddingHorizontal: '5%',
    backgroundColor: '#FFF',
    ...Platform.select({
      web: {
        height: '100dvh',
      },
    }),
  },

  newContainer: {
    flex: 1,
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    ...Platform.select({
      web: {
        height: '100dvh',
      },
    }),
  },

  currencyIconStyles: {
    height: 15,
    width: 15,
  },

  newCurrencyIconStyles: {
    height: 24,
    width: 24,
  },

  currencyText: {
    color: '#FFF',
    fontSize: 18,
  },

  newCurrencyText: {
    ...SkillzStyle.fullStyles.textColorPrimary,
    fontSize: 20,
    fontWeight: '700',
  },

  currencyViewContainer: {
    backgroundColor: '#3CBE33',
    width: 107,
    height: 37,
    alignSelf: 'center',
    borderRadius: 8,
    top: 8,
  },

  newCurrencyViewContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.30)',
    alignSelf: 'center',
    borderRadius: 12,
    padding: 8,
  },

  footerContainer: {
    height: 170,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },

  newFooterContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    bottom: 20,
  },

  footerText: {
    bottom: 16,
    textAlign: 'center',
    maxWidth: 300,
    ...SkillzStyle.fullStyles.fontRegular,
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: '400',
    color: '#1d1d1d',
  },

  newFooterText: {
    // bottom: 16,
    textAlign: 'center',
    maxWidth: 300,
    ...SkillzStyle.fullStyles.fontRegular,
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: '700',
    ...SkillzStyle.fullStyles.textColorPrimary,
    marginBottom: 40,
  },

  image: {
    height: 73,
    width: 105,
  },

  newImage: {
    height: 73,
    width: 105,
    marginVertical: 24,
  },

  header: {
    width: '100%',
    paddingHorizontal: 20,
    marginBottom: 12,
  },

  infoIcon: {
    width: 24,
    height: 24,
    alignSelf: 'flex-end',
    alignItems: 'flex-end',
  },

  imageContainer: {
    // marginTop: '15%',
    // height: 80,
    justifyContent: 'center',
    alignItems: 'center',
  },

  accountCardContainer: {
    marginTop: 20,
    minHeight: 100,
  },

  totalBalance: {
    top: '8%',
    paddingBottom: 10,
  },

  newTotalBalance: {
    paddingVertical: 60,
  },

  totalBalanceView: {
    flexDirection: 'row',
    alignSelf: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    backgroundColor: '#3CBE33',
    marginTop: '2%',
    padding: 8,
  },

  totalBalanceText: {
    color: '#FFF',
    fontSize: 18,
    ...SkillzStyle.fullStyles.fontRegular,
    fontWeight: '600',
    marginLeft: 4,
  },

  currencyIcon: {
    height: 15,
    width: 15,
    alignSelf: 'center',
  },
});
